import { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import config from '../config.js';
import { fetchListConceptes } from '../components/common/SelectConcepte.js';
import DataLoader from '../components/common/DataLoader.js';
import SubdividirMovimentComponent from '../components/common/SubdividirMovimentComponent.js';

const SubdividirMovimentPage = () => {
  const [listConceptes, setListConceptes] = useState(null);

  const { userapp: paramUserapp, id: paramConcMovId } = useParams();
  const userapp = paramUserapp;
  const concMovId = paramConcMovId;

  const fetchFunction = (jwtToken, onData, onError, onFinally) => {
    axios.get(`${config.apiBaseUrl}/v1/concmovs/${concMovId}`, {
      headers: { Authorization: `${jwtToken}` }
    })
      .then((concMovResponse) => {
        const concMovData = concMovResponse.data;
        const movId = concMovData.moviment.id;

        axios.get(`${config.apiBaseUrl}/v1/moviment/${movId}`, {
          headers: { Authorization: `${jwtToken}` }
        })
          .then((movResponse) => {
            onData({
              data: {
                concMov: concMovData,
                moviment: movResponse.data
              }
            });
          })
          .catch((err) => {
            onError(err, 'cargar movimiento');
          })
          .finally(() => onFinally());
      })
      .catch((err) => {
        onError(err, 'cargar concepto original');
        onFinally();
      });

    fetchListConceptes(jwtToken,
      userapp,
      (data) => {
        setListConceptes(data);
      },
      (err) => {
        onError(err, 'cargar conceptos');
      }
    );
  };

  return (
    <DataLoader id={concMovId} fetchFunction={fetchFunction}>
      {(data, onError) => {
        return (
          <SubdividirMovimentComponent
            concMov={data.concMov}
            moviment={data.moviment}
            userapp={userapp}
            listConceptes={listConceptes}
            onError={onError}
          />
        );
      }}
    </DataLoader>
  );
};

export default SubdividirMovimentPage;
